<template>
    <option value="">{{ $t('seleziona-tipologia') }}</option>
    <!-- <option value="casa">{{ $t('casa') }}</option>
    
    <option value="condominio">{{ $t('condominio') }}</option>
    <option value="rustico">{{ $t('rustico') }}</option>
    <option value="villa">{{ $t('villa') }}</option>
    <option value="stabileDiReddito">{{ $t('stabile-di-reddito') }}</option>
    <option value="superficieCommerciale">{{ $t('superficie-commerciale') }}</option> -->
    <option :value="$t('appartamento')">{{ $t('appartamento') }}</option>
    <option :value="$t('casa-villa')">{{ $t('casa-villa') }}</option>
    <option :value="$t('rustico-casa-vacanza')">{{ $t('rustico-casa-vacanza') }}</option>
    <option :value="$t('stabile-di-reddito')">{{ $t('stabile-di-reddito') }}</option>
    <option :value="$t('superficie-commerciale')">{{ $t('superficie-commerciale') }}</option>
    <option :value="$t('hobby-deposito')">{{ $t('hobby-deposito') }}</option>
    <option :value="$t('posteggio')">{{ $t('posteggio') }}</option>
    <option :value="$t('ufficio')">{{ $t('ufficio') }}</option>
    <option :value="$t('terreni')">{{ $t('terreni') }}</option>
    <!-- <option value="negozio">{{ $t('negozio') }}</option>
    <option value="ufficio">{{ $t('ufficio') }}</option>
    <option value="athelier">{{ $t('athelier') }}</option>
    <option value="magazzino">{{ $t('magazzino') }}</option>
    <option value="edificioCommerciale">{{ $t('edificio-commerciale') }}</option>
     -->
</template>

<script>
    export default {
        name: 'SelectTipologiaOptions',
    };
</script>
